import React from "react"
import { useCountUp } from 'react-countup';
 
export const Count = () => {
  const { countUp } = useCountUp({
        start: 4,
        end: 299,
        duration: 200
  });
  return (
      <>{countUp}</>
  );
};